import { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import api from "@/lib/api";
import AuthShell from "@/pages/AuthShell";
import { CheckCircle2, XCircle } from "lucide-react";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [status, setStatus] = useState("loading");
  const fired = useRef(false);
  const { t } = useTranslation();

  useEffect(() => {
    if (!token) { setStatus("error"); return; }
    if (fired.current) return;   // guard React StrictMode double-invoke: single-fire only
    fired.current = true;
    api.post("/auth/verify-email", { token })
      .then(() => setStatus("ok"))
      .catch(() => setStatus("error"));
  }, [token]);

  return (
    <AuthShell title={t("auth.verifyEmailTitle")}>
      <div className="text-center py-4" data-testid="verify-status">
        {status === "loading" && <p className="text-slatebody">{t("auth.verifying")}</p>}
        {status === "ok" && (
          <>
            <CheckCircle2 className="h-12 w-12 text-[#202123] mx-auto mb-3" />
            <p className="text-navy font-medium">{t("auth.emailVerified")}</p>
            <Link to="/login" className="text-[#202123] hover:underline text-sm mt-3 inline-block">{t("auth.continueToLogin")}</Link>
          </>
        )}
        {status === "error" && (
          <>
            <XCircle className="h-12 w-12 text-red-500 mx-auto mb-3" />
            <p className="text-navy font-medium">{t("auth.verifyInvalid")}</p>
            <Link to="/login" className="text-[#202123] hover:underline text-sm mt-3 inline-block">{t("auth.backToLogin")}</Link>
          </>
        )}
      </div>
    </AuthShell>
  );
}
